import { green, headingBlue, lightGrey, maroon, mediumGrey, textColor } from "../../../assets/colors";

export const titleStyle = {
    backgroundColor: headingBlue,
    color: 'white',
    fontSize:'1rem',
    display: "flex",
    alignItems: 'center',
    height: "1.8rem", 
    padding: "0.4rem 0rem 0.4rem 1rem"  
}

export const tableBoxStyle = {
    padding: '1rem 0.5rem 1rem 0.5rem'
}

export const tableTextStyle = {
    fontSize: '0.8rem',
    textAlign: 'center',
    // borderBottom: `0.8px solid ${mediumGrey}`,
    color: green
    // textColor: maroon
    // borderRight: `0.8px solid ${mediumGrey}`
}

export const imageBoxStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center',
    flexDirection: 'column',
    padding: '0.1rem 0.5rem 0.1rem 0.5rem',
    // border: `1px solid ${mediumGrey}`
}

export const imageStyle = {
    width: '4rem',
    height: '4rem'
}